import React from "react";
import { CONDITIONS } from "@/lib/format";
import { useApp } from "@/context/AppContext";
import { cn } from "@/lib/utils";

export function ConditionBadge({ condition, className }) {
  const { lang } = useApp();
  const c = CONDITIONS[condition] || CONDITIONS.good;
  return (
    <span data-testid="product-condition-badge"
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", c.cls, className)}>
      {c[lang]}
    </span>
  );
}
